<template>
  <div
    class="Banner"
    :style="{
      'background-image': `url('${image}')`,
      'background-position': imagepos
    }"
  >
    <div class="BannerGutter">
      <div class="container container--ultrawide">
        <div class="BannerHeader">
          <h1><slot name="title"></slot></h1>

          <div class="BannerCaption">
            <slot name="caption"></slot>
          </div>
        </div>
      </div>

      <div class="BannerTabs">
        <slot name="tabs"></slot>
      </div>
    </div>

    <div class="BannerControls">
      <slot name="controls"></slot>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'image',
    'imagepos'
  ]
};

</script>

<style lang="scss" scoped>
  .Banner {
    display: flex;
    flex-direction: column;
    padding-bottom: 0 !important;
    margin-bottom: 3rem;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .BannerGutter {
    padding: 300px 0 50px;
    position: relative;
    z-index: 100;
    border-bottom: 1px solid rgba(var(--white), .1);
    margin-bottom: 2px;
  }

  .BannerHeader {
    text-align: left;
    margin: 0;
    width: 1600px;
  }

  .BannerHeader h1 {
    font-size: 3.2rem;
  }

  .BannerCaption {
    width: 1200px;
    margin: 2rem 0 4rem 0;
    font-size: 1.25rem;
    line-height: 2rem;
    color: rgba(var(--tan-light), 1);
  }

  .BannerTabs {
    max-width: 1600px;
  }
</style>